import { SidenavFooterItem } from './sidenav-footer-item.interface';

export interface SidenavFooter {
    items: SidenavFooterItem[];
}
